import { useMutation } from "@tanstack/react-query";
import { baseApi } from "./baseApi";
import { BrokerId } from "@/helpers/types";
import { CURRENT_BROKER_ID } from "@/config/logos";

export const usePostRevokeBrokerKeys = () => {
  return useMutation({
    mutationKey: ["revoke-broker-key"],
    mutationFn: async ({
      userId,
      key,
      connection_id,
    }: {
      userId?: string;
      key: string;
      connection_id: string;
    }) => {
      const response = await baseApi.post(
        `/reset_broker_configuration?user_id=${userId}&broker_id=${key}&connection_id=${connection_id}`
      );
      return response;
    },
  });
};

export const usePostSubmitBrokerKeys = () => {
  return useMutation({
    mutationKey: ["submit-broker-key"],
    mutationFn: async ({
      userId,
      key,
      brokerId,
      passphrase,
      secret,
    }: {
      userId?: string;
      key: string;
      brokerId: string;
      passphrase: string;
      secret: string;
    }) => {
      const response = await baseApi.post(
        `/save_broker_api_keys?user_id=${userId}&key=${key}&broker_id=${CURRENT_BROKER_ID}&secret=${secret}&passphrase=${encodeURIComponent(
          passphrase
        )}`
      );
      return response;
    },
  });
};
